import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthAccessProvider} from '../core/core.auth';
import {MessageProvider} from '../service/message.service';
import {UserService} from '../service/user.service';
import {Router} from '@angular/router';
import {UserContext, BaseComponent, BaseResponse, UserInfo, EquipmentUser} from '../core/core.component';
import { EquipmentDefsComponent } from 'app/equipment-defs/equipment-defs.component';

@Component({
  selector: 'app-equipment',
  templateUrl: './equipment.component.html',
  styleUrls: ['./equipment.component.css'],
})
export class EquipmentComponent extends BaseComponent implements OnInit {

  userContext: UserContext;
  userInfo: UserInfo = new UserInfo();

  displayEquipmentDefs = 'active';
  displayEquipmentUsers = '';

  @ViewChild(EquipmentDefsComponent) censimentoChild: EquipmentDefsComponent;
  equipSelected: EquipmentUser = null;

  constructor(protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private userService: UserService) {
    super(authAccess, router, messageProvider);
    this.messageProvider.clearAll();
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
        result => {
          this.userInfo = result;
        },
        error => {
          this.handleError(error);
        });
    }
  }

  display(section: string) {
    this.displayEquipmentDefs = '';
    this.displayEquipmentUsers = '';
    if (section === 'definitions') {
      this.displayEquipmentDefs = 'active';
    } else if (section === 'users') {
      this.displayEquipmentUsers = 'active';
    }
  }

  goToEquip(equip: EquipmentUser){
    this.equipSelected = equip;
    this.censimentoChild.goToEquip(equip);
    this.display('definitions');
  }

}



// WEBPACK FOOTER //
// ./src/app/equipment/equipment.component.ts